import { useContext, useState } from 'react'

import { useException, useLoading, useModal } from 'hooks'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { GradacaoFiltersServices, IAreasAtuacaoResponse, IFaixaFuncionariosResponse, IGraduacaoMultasGetAllResponse, IInfracoesResponse } from 'services/GST/GraduacaoMultas'

import { FineGraduationProvider, FineGraduationContext } from './provider'

interface IUseFineGraduationReturn {
  handleSelectMulta: (multa: IGraduacaoMultasGetAllResponse) => void
  multaSelecionadaParaEdicao: IGraduacaoMultasGetAllResponse
  handleClearMultaSelecionada: () => void
  handleGetAreas: () => void
  areasList: IAreasAtuacaoResponse[]
  handleGetQuantidadeFuncionarios: () => void
  faixaFuncionariosList: IFaixaFuncionariosResponse[]
  handleGetInfracoes: () => void
  infracoesList: IInfracoesResponse[]
}

const useFineGraduation = (): IUseFineGraduationReturn => {
  const {
    multaSelecionada: multaSelecionadaParaEdicao,
    setMultaSelecionada,
    areasObjList: areasList,
    faixaFuncionariosObjList: faixaFuncionariosList,
    infracoesObjList: infracoesList,
    setAreasObjList,
    setFaixaFuncionariosObjList,
    setinfracoesObjList,
  } = useContext(FineGraduationContext)

  const { getException, createCustomException } = useException()
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const handleSelectMulta = (multa: IGraduacaoMultasGetAllResponse) => {
    setMultaSelecionada(multa)
  }

  const handleClearMultaSelecionada = () => {
    setMultaSelecionada(undefined)
  }

  const handleGetAreas = () => {
    GradacaoFiltersServices()
      .getAreasAtuacaoList()
      .then((response) => {
        if (response?.status !== 200) {
          const { detalhe, mensagem, tipo } = response?.data;

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao carregar os filtros.',
            tipo: IResponseTypes[tipo]
          })
        }

        setAreasObjList(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      });
  }

  const handleGetQuantidadeFuncionarios = () => {
    GradacaoFiltersServices()
      .getFaixaFuncionariosList()
      .then((response) => {
        if (response?.status !== 200) {
          const { detalhe, mensagem, tipo } = response?.data;

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao carregar os filtros.',
            tipo: IResponseTypes[tipo]
          })
        }

        setFaixaFuncionariosObjList(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      });
  }

  const handleGetInfracoes = () => {
    GradacaoFiltersServices()
      .getInfracoesList()
      .then((response) => {
        if (response?.status !== 200) {
          const { detalhe, mensagem, tipo } = response?.data;

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao carregar os filtros.',
            tipo: IResponseTypes[tipo]
          })
        }

        setinfracoesObjList(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      });
  }

  return {
    areasList,
    faixaFuncionariosList,
    handleClearMultaSelecionada,
    handleGetAreas,
    handleGetInfracoes,
    handleGetQuantidadeFuncionarios,
    handleSelectMulta,
    infracoesList,
    multaSelecionadaParaEdicao
  }
}

export {
  useFineGraduation,
  FineGraduationProvider,
}
